export default {
  notifications: {
    message: {
      system: "{name} sent you a notification",
      pass_approval_requested: "{name} submitted a pass request to review",
      pass_approved: "{name} approved your pass request{guest}",
      pass_rejected: "{name} declined your pass request{guest}",
      // The doorbell names the visitor and the unit, not the actor — the
      // résident has two seconds and the gardien's name isn't the point.
      spot_arrival_requested: "{visitor} is at the gate for {unit} — allow?",
      guest_arrived: "{guest} has arrived · {unit}",
      guest_completed: "{guest} completed their details",
      parcel_received: "A parcel is waiting for you {desk} · {unit}",
      parcel_reminder:
        "Your parcel has been waiting {desk} for {days} days · {unit}",
      parcel_handed_over: "Parcel handed over {collector} · {unit}",
      booking_requested: "{actor} requests {booking}",
      booking_confirmed: "Booking confirmed · {booking}",
      booking_rejected: "Booking declined · {bookingDay}{reason}",
      booking_cancelled: "Booking cancelled · {booking}",
      booking_reminder: "Starting soon: {booking}",
    },
    // Inbox-only overrides — see fr.ts. Only the doorbell differs.
    inbox: {
      spot_arrival_requested: "Unannounced visitor: {visitor} · {unit}",
    },
  },
} as const;
